import styled, { keyframes } from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';
import { NoteCaptureCard } from './shared.style';

export const Card = styled(NoteCaptureCard)`
  min-height: 360px;
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 15px 15px 0;
  box-sizing: border-box;
`;

export const ContentSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 15px 20px 10px;
  width: 100%;
  box-sizing: border-box;
`;

export const FeedbackText = styled(Text.H5)`
  width: 100%;
  color: ${colours.neutral[900]};
  text-align: center;
`;

export const ResolveHint = styled(Text.P1)`
  width: 100%;
  color: ${colours.neutral[400]};
  text-align: center;
`;

export const ControlsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px 15px;
  width: 100%;
  box-sizing: border-box;
`;

export const ControlsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AttachmentsRow = styled.div`
  display: flex;
  padding: 0 15px 10px;
  width: 100%;
  box-sizing: border-box;
`;

export const AttachmentError = styled.div`
  width: 100%;
  padding: 0 15px 10px;
  box-sizing: border-box;
  font-family: 'Inter Variable', 'Inter', sans-serif;
  font-size: 13px;
  line-height: 18px;
  color: ${colours.primary[500]};
`;

export const PausedStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const PausedTitle = styled(Text.H4)`
  color: ${colours.neutral[900]};
  text-align: center;
`;

export const WaveformContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  overflow: hidden;
  height: 40px;
  width: 100%;
`;

const pulseAnimation = keyframes`
  0%, 100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(0.6);
  }
`;

export const WaveformBar = styled.div<{
  $height: number;
  $delay: number;
  $isAnimating: boolean;
}>`
  width: 5px;
  border-radius: 3px;
  background-color: ${colours.neutral[500]};
  transition: height 0.15s ease-out;
  height: ${({ $height }) => $height}px;
  min-height: 3px;
  max-height: 40px;
  animation: ${({ $isAnimating }) => ($isAnimating ? pulseAnimation : 'none')}
    0.8s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;
